function getLanguage() {
    // Extract language from URL if not provided
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    let language = (pathSegments.length > 0 ? pathSegments[0] : "sv-SE");

    // Normalize lang format (e.g., sv-se -> sv-SE)
    if (language.includes("-")) {
        const [base, region] = language.split("-");
        language = `${base}-${region.toUpperCase()}`;
    }

    return language;
}

function getAllCheckboxes() {
    return document.querySelectorAll('.filter-checkbox');
}

var findExercise = {
    initFilters: () => {
        const locationBtn = document.getElementById('location-btn');
        const listViewBtn = document.getElementById('list-view-btn');
        const mapViewBtn = document.getElementById('map-view-btn');

        if (listViewBtn) listViewBtn.addEventListener('click', () => toggleView(true));
        if (mapViewBtn) mapViewBtn.addEventListener('click', () => {
            if (mapCheck()) {
                return
            } else toggleView(false)
        });
        if (locationBtn) locationBtn.addEventListener('click', () => handleShowPosition());
        // Call applyFilters initially
        applyFilters();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    findExercise.initFilters();

    const getParams = () => {
        const urlParams = new URLSearchParams(window.location.search);

        const parseParamArray = (paramKey) => {
            const values = urlParams.getAll(paramKey);
            return values
                .flatMap(v => v.split(','))
                .map(v => v.trim())
                .filter(Boolean);
        };

        const trainingforms = checkedFilters.workouttypes?.length
            ? checkedFilters.workouttypes
            : parseParamArray("workouttypes");

        const conveniences = checkedFilters.conveniences?.length
            ? checkedFilters.conveniences
            : parseParamArray("conveniences");

        const area = checkedFilters.city?.length
            ? checkedFilters.city
            : urlParams.get("city");


        return { trainingforms, conveniences, area };
    };

    window.getParams = getParams;
});
